import { render } from "./StaffPortal.vue?vue&type=template&id=1045058c"
import script from "./StaffPortal.vue?vue&type=script&lang=js"
export * from "./StaffPortal.vue?vue&type=script&lang=js"

import "../staff-portal.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__